@if (!isModal) {
  <split-pane-main-header>
    <ion-buttons slot="end">
      <new-dataset-button></new-dataset-button>
    </ion-buttons>
  </split-pane-main-header>
  <split-pane-main-content [rootPath]="rootPath" secondaryContentType="routerOutlet">
    <div class="split-pane-main-col1-content">
      <ng-container *ngTemplateOutlet="ListPageTemplate"></ng-container>
    </div>
  </split-pane-main-content>
} @else {
  <ng-container *ngTemplateOutlet="ListPageTemplate"></ng-container>
}

<ng-template #ListPageTemplate>
  <ion-header mode="ios" class="ion-no-border">
    @if (isModal) {
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button fill="clear" color="dark" mode="ios" (click)="dismiss()">
            {{ 'BUTTON.CANCEL' | translate }}
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          @if (enableAllSelection && isMultiSelect) {
            <ion-button fill="clear" color="primary" mode="ios" (click)="toggleSelectAllInFilter()">
              {{ (allSelectedInFilter ? 'BUTTON.CLEAR_SELECTION' : 'BUTTON.SELECT_ALL') | translate }}
            </ion-button>
          }
          <ion-button strong fill="clear" color="primary" mode="ios" (click)="submit()">
            {{ 'BUTTON.SAVE' | translate }}
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    } @else if (isPublicWebApp) {
      <ion-toolbar class="search-info-toolbar">
        <div class="search-info-toolbar-text">
          <h5 class="search-info-toolbar-title" [title]="'VIEW.TOPIC_LIST.SEARCH_INFO.TITLE' | translate">
            <span>{{ 'VIEW.TOPIC_LIST.SEARCH_INFO.TITLE' | translate }}</span>
            <ion-button class="search-info-toolbar-help-button" fill="clear" size="small" strong
              routerLink="/main/faq" [queryParams]="{ id: 'topic' }">
              <ion-icon name="help-circle-outline"></ion-icon>
              {{ 'BUTTON.HELP' | translate }}
            </ion-button>
          </h5>
          <p class="search-info-toolbar-description" [title]="'VIEW.TOPIC_LIST.SEARCH_INFO.DESCRIPTION' | translate">
            {{ 'VIEW.TOPIC_LIST.SEARCH_INFO.DESCRIPTION' | translate }}
          </p>
        </div>
      </ion-toolbar>
    }
    <search-toolbar
      [currentMultiFieldSearchValue]="currentSearchValue"
      [filterIsActive]="filterIsActive"
      [multiFieldSearchPlaceholderKey]="'VIEW.TOPIC_LIST.SEARCH.PLACEHOLDER'"
      [showFilter]="!showRareDiseaseToggle"
      [showLocationSearch]="false"
      [searchOnInputChange]="true"
      [isLoading]="viewStates[currentContentId].isLoading"
      [showSkeleton]="viewStates[currentContentId].showSkeleton"
      (multiFieldSearchInput)="onSearchValueUpdated($event)"
      (filterClicked)="onFilterButtonClicked()">
      <div class="toolbar-meta-wrapper">
        <div class="toolbar-meta">
          <span>{{ totalItemsInDatabase }} {{ 'TERM.SEARCH_RESULT' | translate }}</span>
          @if (!isPublicWebApp) {
            <ion-button class="search-info-button" color="primary" fill="clear" size="small" (click)="openSearchInfoPopover($event)">
              <ion-icon name="information-circle" slot="icon-only"></ion-icon>
            </ion-button>
            <ion-popover class="search-info-popover" mode="md"
              [event]="searchInfoPopoverEvent"
              [isOpen]="isSearchInfoPopoverOpen"
              (didDismiss)="isSearchInfoPopoverOpen = false"
              show-backdrop="false">
              <ng-template>
                <ion-content>
                  <div class="search-info-content">{{ 'VIEW.TOPIC_LIST.SEARCH.MULTI_FIELD_TOOLTIP' | translate }}</div>
                </ion-content>
              </ng-template>
            </ion-popover>
          }
          @if (showRareDiseaseToggle) {
            <div class="toolbar-meta-toggle-wrapper">
              <ion-toggle class="toolbar-meta-toggle" mode="md" labelPlacement="end"
                [checked]="showOnlyRareDiseases"
                (ionChange)="onRareDiseaseUpdated($event)">
                {{ 'FORM.INPUT.IS_RARE_DISEASE.LABEL' | translate }}
              </ion-toggle>
            </div>
          }
        </div>
      </div>
    </search-toolbar>
  </ion-header>
<ion-content class="nakos-list-content" #ListContent
  [ngClass]="{
    'modal-content': isModal,
    'show-skeleton': viewStates[currentContentId].showSkeleton,
    'is-loading': viewStates[currentContentId].isLoading }">
  <ion-refresher slot="fixed"
    [disabled]="viewStates[currentContentId].showSkeleton"
    (ionRefresh)="refresh(currentContentId, $event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <div class="proto-content">
    <ion-radio-group [ngModel]="selectedItemIds[0]">
      <ion-list lines="none">
        @for (item of items[currentContentId]; let i = $index; track item ? item.id : i) {
          <topic-preview
            [ngClass]="{ 'is-selected': item?.id === activatedRouteId }" [type]="currentListType"
            [item]="item"
            (openDetail)="onItemClicked($event)">
            @if (isModal) {
              @if (!isMultiSelect) {
                <ion-radio class="list-item-checkbox" [value]="item?.id"></ion-radio>
              } @else {
                <ion-checkbox class="list-item-checkbox" [checked]="selectedItemIds.includes(item?.id)"></ion-checkbox>
              }

            }
          </topic-preview>
        }
      </ion-list>
    </ion-radio-group>


    @if (viewStates[currentContentId].isEmpty || viewStates[currentContentId].hasError) {
      <unavailable-block
        [permissionDenied]="hasUnauthorizedError"
        [viewStates]="viewStates[currentContentId]"
        (refresh)="refresh(currentContentId)">
      </unavailable-block>
    }
  </div>

  <ion-infinite-scroll
    [disabled]="!viewStates[currentContentId].hasMore"
    (ionInfinite)="loadMore(currentContentId, $event)">
    <ion-infinite-scroll-content>
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
</ng-template>
